/**
 * 公共翻译
 **/
const en = {
  global: {
    home: 'Home',
    logout: 'Logout',
    language: {
      chinese: 'Chinese',
      english: 'English'
    },

    search: "Search", // 搜索
    actions: "Actions",
    edit: "Edit", // 编辑
    modify: "Modify", // 修改
    detail: "Detail", // 详情
    details: "Details", // 明细
    add: "Add", // 新增
    delete: "Delete", // 删除
    cancel: "Cancel", // 取消
    more: "More", // 更多
    export: "Export", // 导出
    select: "Select", // 选择
    close: "Close", // 关闭
    confirm: "Confirm", // 确定
    generate: "Generate", // 生成
    logoutConfirm: "Confirm to logout?", // 确认要退出吗?
    noAccess: "Access denied: User does not have permission to log in.", // 您尚未开通访问权限。
    noPermission: "No permission, please contact the administrator!" // 无权限，请联系管理员！
  },

  datepicker: {
    recentAweek: "Last Week", // 最近一周
    recentAmoon: "Last Month", // 最近一个月
    recentThreeMonth: "Last 3 Months", // 最近三个月
  },

  select: {
    select: "Please select", // 请选择
    // head: "Please select project", // 请选择项目
    // grp: "Please select merchant group", // 请选择商户组
    // mer: "Please select outlet", // 请选择营业点
    head: "Project", // 请选择项目
    grp: "Merchant Group", // 请选择商户组
    mer: "Outlet", // 请选择营业点
    status: "Please select status", // 请选择状态
    payType: "Please select payment method", // 请选择支付方式
    txnType: "Please select payment product", // 请选择支付产品
    txnId: "Please select transaction type", // 请选择交易类型
    chType: "Please select payment channel", // 请选择支付通道
    month: "Select month", // 选择月
  },

  input: {
    input: "Please enter", // 请输入
    tellerNo: "Please enter operator ID", // 请输入操作员
    inputHeadCode: "Please enter project code", // 请输入项目代码
    inputHeadName: "Please enter project name", // 请输入项目名称
    inputGrpCode: "Please enter merchant group code", // 请输入商户组代码
    inputGrpName: "Please enter merchant group name", // 请输入商户组名称
    inputMerCode: "Please enter outlet code", // 请输入营业点代码
    inputMerName: "Please enter outlet name", // 请输入营业点名称

    headCode: "Project code", // 请输入项目代码
    headName: "Project name", // 请输入项目名称
    grpCode: "Merchant group code", // 请输入商户组代码
    grpName: "Merchant group name", // 请输入商户组名称
    merCode: "Otlet code", // 请输入营业点代码
    merName: "Outlet name", // 请输入营业点名称
    memo: "Please enter remarks", // 请输入备注
  },

  // 状态翻译
  status: {
    normal: "Normal", // 正常
    disabled: "Disabled", // 禁用
    start: "Enabled", // 启用
    initial: "Initial", // 初始
    lock: "Locked", // 锁定
    completed: "Completed", // 已完成
    incomplete: "Incomplete", // 未完成
    expired: "Expired", // 已过期
    enabled: "Activated", // 开通
    closed: "Closed", // 关闭
    yes: "Yes", // 是
    no: "No", // 否
    success: "Success", // 成功
    failure: "Failure", // 失败
    revoked: "Revoked", // 已撤销
    pendingReview: "Pending Review", // 待审核
    pendingExecution: "Pending Execution", // 待执行
    executing: "Executing", // 执行中
    executed: "Executed", // 已执行
    voided: "Voided", // 已作废
    inProgress: "In Progress", // 处理中
    notActivated: "Not Activated", // 未开通
    activated: "Activated", // 开通
  },

  list: {
    code: "Code", // 代码
    group: "Group", // 集团
    brand: "Brand", // 品牌
    partner: "Partner", // 合作伙伴
    head: "Project", // 项目
    grp: "Merchant Group", // 商户组
    mer: "Outlet", // 营业点
    // belGroup: "Belonging Group", // 所属集团
    // belBrand: "Belonging Brand", // 所属品牌
    // belHead: "Belonging Project", // 所属项目
    // belGrp: "Belonging Merchant Group", // 所属商户组
    // belMer: "Belonging Outlet", // 所属营业点
    belGroup: "Group", // 所属集团
    belBrand: "Brand", // 所属品牌
    belHead: "Project", // 所属项目
    belGrp: "Merchant Group", // 所属商户组
    belMer: "Outlet", // 所属营业点
    headCode: "Project Code", // 项目代码
    headName: "Project Name", // 项目名称
    grpCode: "Merchant Group Code", // 商户组代码
    grpName: "Merchant Group Name", // 商户组名称
    merCode: "Outlet Code", // 营业点代码
    merName: "Outlet Name", // 营业点名称
    status: "Status", // 状态
    creDate: "Creation Date", // 创建时间
    modiDate: "Modification Date", // 修改时间
    memo: "Remarks", // 备注
    summaryPeriod: "Date Range", // 日期范围
    to: "to", // 至
    operatorSettings: "Operator Settings", // 操作员设置
  },

  login: {
    title: 'Shiji Reconciliation System',
    tips:'简体中文',
    loginBtn:'Sign in',
    accounts_pass_login:'Account Password Login',
    scan_code_login:'Scan Code Login',
    remember:'Remember',
    welcomeBack:'Welcome back',
    forget_pass:'Forget The Password ',
    username_placeholder:'Please input username',
    password_placeholder:'Please input a password',
    verifyCode_placeholder:'Please input verifyCode',
    password_invaild:'Password length cannot be less than 6 digits',
    homepage:"Return to Home",   // 返回首页
    webpageLost:"the webpage is lost!",   // 网页丢失啦！
    otherLogin: "Other login methods",
    scancodeLogin: "Scan code quick login",
    marriott: "Marriott",
    llshr: "Lego",
    daylight: "Daylight"
  },

  auth: {
    identity: {
      select: "Select Identity", // 选择身份
      switch: "Switch Identity", // 切换身份
      invalid: "Current identity does not exist, please login again", // 当前身份不存在，请重新登录
      current: "Current", // 当前
      selected: "Current organization selected~", // 已选择当前机构~
      logoutConfirm: "Confirm to logout?", // 确认要退出吗?
      pwdExpired: "Password has expired, please change it immediately!"  // 密码已过期，请立即修改！
    },
    session: {
      timeout: "User inactive for too long, please login again?", // 用户长时间无操作，请重新登录?
      expired: "Current session expired, please login again", // 当前会话已过期，请重新登录
      relogin: "Re-login", // 重新登录
      pwdExpired: "Password has expired, please change it immediately!"  // 密码已过期，请立即修改！
    }
  },
  system: {
    api: {
      defaultError: "System API {error} exception", // 系统接口{error}异常
      connectionError: "Backend API connection exception", // 后端接口连接异常
      timeout: "System API request timeout" // 系统接口请求超时
    }
  },
  user: {
    profile: "Profile", // 个人信息
    name: "Name", // 姓名
    account: "Account", // 账号
    type: "Type", // 类型
    admin: "Administrator", // 管理员
    brand: "Brand User", // 品牌用户
    projectAdmin: "Project Administrator", // 项目-管理员
    projectStaff: "Project Staff", // 项目-员工
    group: "Group User", // 集团用户
    logout: "Logout", // 退出登录
    loginAccount: "Login Account", // 登录账号
    initialPassword: "Initial Password", // 初始密码
    resetPassword: "Reset Password", // 重置密码
    changePwd: "Change Password", // 修改密码
    userCode: "User Code", // 用户代码
    userName: "User Name", // 用户姓名
    mobile: "Mobile Number", // 手机号
    validation: {
      account: "Please enter account", // 请输入账号
      name: "Please enter user name", // 请输入用户姓名
      charset: "Only numbers, letters or '.' are supported", // 仅支持输入数字、字母或'.'
      mobile: "Please enter mobile number", // 请输入手机号
      lengthRule: "Mobile number cannot exceed 11 digits", // 手机号码不能超过11位
      formatRule: "Please enter valid mobile number", // 请输入正确的手机号码
      userExpDateNotNull: "Expiration date cannot be empty", // 过期日期不能为空
    },
  },
  resetPwd: {
    title: "Please enter your email",
    email: "Email",
    smsCode: "Verification Code",
    emailInput: "Please enter email",
    smsCodeInput: "Please enter verification code",
    step1: "Email Verification",
    step2: "Email Sent Successfully",
    step3: "Reset Password",
    step4: "Completed",
    tip1: "An email has been sent to your mailbox",
    tip2: "Please go to your mailbox to complete the password reset",
    toLogin: "Return to Login", // 返回登录
    pwdStrong: "Password Strength",
    success: "success",
    reserPwdSuccess: "Password Reset Successfully",
    linkInvalid: "Verification link is invalid or has expired!",
    pwdValid1: "Please enter password",
    pwdValid2: "Password length must be 12-20 characters",
    pwdValid3: "Password must contain both letters and numbers",
    pwd2Valid1: "Please re-enter password",
    pwd2Valid2: "Passwords do not match",
    pwd2Valid3: "Password length must be 12-20 characters",
    pwd2Valid4: "Password must contain both letters and numbers",
    emailValid1: "Please enter valid email",
    smsCodeValid1: "Please enter valid verification code",
    applyResetPwdSuccess: "Password reset request submitted successfully",
    title2: "Please reset your password",
    password: "New Password",
    password2: "Confirm Password",
  },
  updatePwd: {
    name: "updatePwd",
    userCode: "userCode",
    title2: "pelease enter your old password",
    oldUserPwd: "Old Password",
    newUserPwd: "New Password",
    newUserPwd2: "Repeat New Password",
    complete: "Complete",
    pwdStrong: "Password Strength:",
    success: "Success",
    pwdSuccess: "Password changed successfully",
    toLogin: "Return to Login",
    confirm: "Confirm",
    pwdValid1: "Please enter new password",
    pwdValid2: "Password length must be 12-20 characters",
    pwdValid3: "Password must contain both letters and numbers",
    pwdValid4: "New password and old password cannot be the same",
    pwd2Valid1: "Please enter new password",
    pwd2Valid2: "Two passwords do not match",
    pwd2Valid3: "Password length must be 12-20 characters",
    pwd2Valid4: "Password must contain both letters and numbers",

  },
  email: {
    label: "Email", // 邮箱
    loginEmail: "Login Email", // 登录邮箱
    placeholder: 'Please enter email',
    userCodeEmail: "Login account, please provide your real email address", // 登录账号，请填写自己真实的邮箱
    validation: {
      required: "Please enter email", // 请输入邮箱
      invalid: "Please enter valid email format", // 请输入正确的邮箱格式
      real: "Please provide your real email address", // 请填写自己真实的邮箱
    },

    actions: {
      submit: "Confirm Submit", // 确认提交
      changePassword: "Change Password", // 修改密码
      confirmChange: "Confirm to change password?", // 您确定修改密码吗?
      resetConfirm: "Confirm to reset user password?", // 确定要重置该用户密码?
      warnTips: "Confirm to delete this data item?", // 是否确认删除此数据项?
    },
    notifications: {
      noEmail: "No email address, please add email first,", // 暂无邮箱，请先补填邮箱
      sentInstructions: "After confirmation, password change email will be sent to your mailbox, open the link in the email to complete password change.", // 确认后，将向您的邮箱发送密码修改邮件，打开邮件中的链接完成密码修改
      success: "Operation successful. Password reset email has been sent to operator's mailbox, please check and reset password.", // 操作成功。已发送重置密码邮件到操作员邮箱，请注意查收邮件，并重置密码
      resetSuccess: "Operation successful. Password reset email has been sent to operator's mailbox, please notify operator to check email and reset password.", // 操作成功。已发送重置密码邮件到操作员邮箱，请通知操作员查收邮件，并重置密码
      operatorLimit: "Note: Maximum 3 operators can be added", // 提示：操作员最多可新增三个
      operatorSetup: "1. Maximum 3 operators can be configured", // 1. 最多可设置3名操作员
      operatorTitle: "2. After addition, activation email with password setup link will be sent to operator's mailbox. Account will be active after password configuration.", // 2. 新增完毕后，操作员邮箱将会收到激活并设置密码的邮件，激活和设置密码后，可正常使用

    }
  },

  // 校验规则翻译
  rule: {
    head: "Please select project", // 请选择项目
    grp: "Please select merchant group", // 请选择商户组
    mer: "Please select outlet", // 请选择营业点
    notNullDate: "Date cannot be empty!", // 日期不能为空！
    startNotgreaterEndTime: "Start date cannot be later than end date!", // 起始日期不能大于结束日期！
    exceedThirtyDays: "Date range cannot exceed 31 days!", // 日期范围不能超过31天！
    exceedOneYear: "Date range cannot exceed one year!", // 日期范围不能超过一年！
    exceedTwoMonths: "Date range cannot exceed two months!", // 日期范围不能超过两个月！
  },

  // 提示信息、报错翻译
  promptBox: {
    prompt: "Tip", // 提示
    queryLoading: "Querying...", // 正在查询...
    querydata: "Click search to query data", // 点击搜索，查询数据
    emptyText: "No Data", // 暂无数据
    errorService: "Sorry, server encountered an issue, please try again later～", // 抱歉，服务器出了点问题，稍后重试～
    NoDataOut: "No data to export!", // 暂无数据导出!
    warn: "Warning", // 警告
    deleteSuccess: "Delete successful", // 删除成功
    editSuccess: "Modification successful.", // 修改成功
    addSuccess: "Addition successful.", // 新增成功
    error: "Error", // 错误
  },

}; 
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en/public.js